import React, { useState, useEffect } from "react"
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import { Card, CardBody, Col, Collapse, Label, Row } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import DatePicker from "react-datepicker"
import classnames from "classnames"
import Lightbox from "react-image-lightbox"
import { clientScreen } from "store/workreport/action"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes"
import { isEmpty } from "lodash"
import HandlingAccordian from "../VerifyMyTeams/HandlingForScroll"

function ClientViewsScreen() {
  //meta title
  document.title = `Welcome | TenderSoftware - Flexi TracBoard`
  const dispatch = useDispatch()

  const { clientscreens } = useSelector(state => ({
    clientscreens: state?.workreport?.clientscreenSuccessList,
  }))

  const searchParams = new URLSearchParams(window.location.search)
  const accountIdfromParams = searchParams.get("accountId")
  const DatefromParams = searchParams.get("date")
  const subcategory = searchParams.get("subcategoryId")
  const clientId = searchParams.get("clientId");

  const [handleAccordion, sethandleAccordion] = useState(false)
  const [handleAccordionimage, sethandleAccordionimage] = useState(false)
  const [handleAccordiondate, sethandleAccordiondate] = useState(false)
  const [isGallery, setisGallery] = useState(false)
  const [photoIndex, setphotoIndex] = useState(null)
  const [startDate, setStartDate] = useState(DatefromParams ? new Date(DatefromParams.replace(/-/g, '\/')) : new Date())
  const fromDate = moment(new Date(startDate)).format("YYYY-MM-DD")
  const [datass, setData] = useState([])
  const [selectedOptions, setSelectedOptions] = useState([])

  const params = {
    date: fromDate,
    clientId
  }

  useEffect(() => {
    console.log(params, 'params');
    const authUser = localStorage.getItem('authUser');
    if (authUser) {
      if (params.clientId) {
        dispatch(clientScreen(params))
      } else {
        const authUserJS = JSON.parse(authUser);
        dispatch(clientScreen({ ...params, clientId: authUserJS?.data?.categoryid }))
      }
    }
  }, [])
  const startDateChange = date => {
    setStartDate(date)
  }


  useEffect(() => {
    if (subcategory || accountIdfromParams) {
      const getSubCategoryData = (datass || []).filter(item => item?.subcategoryId == subcategory)
      const findIndexOfSubCategory = (datass || []).findIndex(item => item?.subcategoryId == subcategory)
      const findIndexOfAccountId = (getSubCategoryData[0]?.data || []).findIndex((item) => item.accountId == accountIdfromParams)
      sethandleAccordion(parseInt(findIndexOfSubCategory))
      sethandleAccordionimage(parseInt(findIndexOfAccountId))
      sethandleAccordiondate(parseInt(findIndexOfSubCategory))
    }
  }, [datass])

  useEffect(() => {
    const reportsX = (clientscreens || []).map((el, key) => {
      return {
        ...el,
        id: key,
        date: el.date,
        data: el.userHoursList,
      }
    })
    const filterData = reportsX?.map(item => {
      return {
        ...item,
        userHoursList: (item?.userHoursList || []).filter(el => {
          if (selectedOptions.length > 0) {
            return selectedOptions.some(items => {
              return items.value === el.userName
            })
          } else {
            return el;
          }
        }
        ),
      }
    })
    console.log(filterData, 'filterData');
    setData(filterData)
  }, [clientscreens, selectedOptions])

  const handleSubmit = () => {
    const authUser = localStorage.getItem('authUser');
    const authUserJS = JSON.parse(authUser);
    dispatch(clientScreen({ ...params, clientId: params?.clientId ? params?.clientId : authUserJS?.data?.categoryid }))
  }
  // top accordian concept
  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }

  //date wise
  const handleOnclickAccordionDate = value => {
    if (handleAccordiondate === value) {
      sethandleAccordiondate(null)
    } else {
      sethandleAccordiondate(value)
    }
  }

  //image accordian
  const handleOnclickAccordionImage = value => {
    if (handleAccordionimage === value) {
      sethandleAccordionimage(null)
    } else {
      sethandleAccordionimage(value)
    }
  }

  // lightbox gallery concept

  const findCategory = datass[handleAccordion]
  const findAccount = (findCategory?.data || [])[handleAccordionimage]
  const images = (findAccount?.screenList || []).map(el => el?.imagePath)

  const usernames = clientscreens?.map((el, ids) =>
    el.userHoursList?.map(el => el.userName)
  )
  //list by username
  const username = usernames?.flat(Infinity) || []
  // multiple select checkbox function start
  const options = username?.map((el, idx) => ({
    id: idx + 1,
    value: el,
    label: el,
  }))

  useEffect(() => {
    if (clientscreens?.length > 1) {
      setSelectedOptions([{ label: "All", value: "*" }, ...options])
    }
  }, [clientscreens])

  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some(o => o.value === "*")) {
      return `${placeholderButtonLabel}: All`
    } else {
      return `${placeholderButtonLabel}: ${value.length} selected`
    }
  }

  function onChange(value, event) {
    if (event.action === "select-option" && event.option.value === "*") {
      this.setState(this.options)
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      this.setState([])
    } else if (event.action === "deselect-option") {
      this.setState(value.filter(o => o.value !== "*"))
    } else if (value.length === this.options.length - 1) {
      this.setState(this.options)
    } else {
      this.setState(value)
    }
  }
  //  end in multi select //

  return (
    <React.Fragment>
      <div className="page-content" style={{ marginTop: "20px" }}>
        <div className="container-fluid">
          <Breadcrumbs title={"Welcome"} breadcrumbItem={`Welcome Tsi`} />
          {isGallery ? (
            <>
              <Lightbox
                mainSrc={images[photoIndex]}
                nextSrc={images[(photoIndex + 1) % images.length]}
                prevSrc={
                  images[(photoIndex + images.length - 1) % images.length]
                }
                enableZoom={true}
                onCloseRequest={() => {
                  setisGallery(false)
                }}
                onMovePrevRequest={() => {
                  setphotoIndex(
                    (photoIndex + images.length - 1) % images.length
                  )
                }}
                onMoveNextRequest={() => {
                  setphotoIndex((photoIndex + 1) % images.length)
                }}
              />
            </>
          ) : null}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col sm={6}>
                      <Row>
                        <Col sm={1} className="d-flex align-items-center">
                          <Label className="d-flex  m-0">
                            Date <span style={{ color: "red" }}>*</span>
                          </Label>
                        </Col>
                        <Col sm={3} className="dat-client">
                          <div className="mx-2">
                            <DatePicker
                              dateFormat="yyyy-MM-dd"
                              className="form-control mb-0 date-icon-back"
                              placeholderText="Select date"
                              maxDate={new Date()}
                              selected={startDate}
                              style={{ width: "50%" }}
                              onChange={startDateChange}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>

                    <Col sm={6}>
                      <Row className=" justify-content-end">
                        <Col sm={4}>
                          {clientscreens?.length > 1 && (
                            <ReactMultiSelectCheckboxes
                              options={[
                                { label: "All", value: "*" },
                                ...options,
                              ]}
                              placeholderButtonLabel="Developer"
                              getDropdownButtonLabel={getDropdownButtonLabel}
                              value={selectedOptions}
                              onChange={onChange}
                              setState={setSelectedOptions}
                              className="checkbox-multi"
                            />
                          )}
                        </Col>
                        <Col sm={1} style={{ width: "13%" }} className="client-submit">
                          <button
                            className="btn btn-primary m-0"
                            type="submit"
                            onClick={handleSubmit}
                          >
                            Search
                          </button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* accordian concept implement */}
          {!isEmpty(datass) &&
            <HandlingAccordian
              datass={datass}
              handleAccordion={handleAccordion}
              handleOnclickAccordion={handleOnclickAccordion}
              handleOnclickAccordionDate={handleOnclickAccordionDate}
              handleAccordiondate={handleAccordiondate}
              handleAccordionimage={handleAccordionimage}
              handleOnclickAccordionImage={handleOnclickAccordionImage}
              setisGallery={setisGallery}
              setphotoIndex={setphotoIndex}
              subcategory={subcategory}
              accountIdfromParams={accountIdfromParams}
              noLightBox
            />
          }
          {clientscreens === null && (
            <Card>
              <CardBody>
                <div>
                  <div className="text-center">No Records Found</div>
                </div>
              </CardBody>
            </Card>
          )}
          {clientscreens?.length === 0 && (
            <Card>
              <CardBody>
                <div>
                  <div className="text-center">No Records Found</div>
                </div>
              </CardBody>
            </Card>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default ClientViewsScreen
